import { createContext } from "react";

export const OrderContext = createContext();

export const OrderContextProvider = ({ children, value }) => (
    <OrderContext.Provider value={value}>{children}</OrderContext.Provider>
);
